import React from "react";
import Helmet from "react-helmet";
import { Fade } from "react-reveal";
import { Link } from "react-router-dom";
import Linkdein from "../../images/Svg/Linkdein.svg";
import TeamData from "./Team.data";

const Team = () => {
  return (
    <Fade cascade duration={1000}>
      <div className="container px-4 sm:px-4  md:px-12 py-8 mx-auto">
        <Helmet>
          <title>Meet The Team - Setu</title>
          <meta
            name="description"
            content="Meet the team behind the vision. Empowering creators to join web 3.0 seamlessly for free.  Earn more, own your content, and expand your brand."
          />
        </Helmet>
        <div className="text-center  md:mx-auto ">
          <h1 className="heading">The team that created this vision</h1>
          <p className="text-base text-[#161616] max-w-[545px] mx-auto mt-4">
            Being creators ourselves, we understand the problem creator’s face.
            Our vision is to enable every creator, to increase their footprint
            in Web 3.0 so they can earn more money, expand their value, and own
            their content.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-3 mx-auto  gap-6 my-12 px-10  w-full ">
          {TeamData?.map((data, index) => (
            <div
              className="lg:flex items-center justify-center mx-auto border-[#E1E1E1] p-8 rounded-[8px] shadow h-full mt-4 w-full"
              key={index}
            >
              <img className="mx-auto" src={data?.icon} alt="" />
              <div className="mt-4 sm:mt-4 lg:mt-0">
                <p className="text-[#161616] ml-4 text-[20px] font-bold">
                  {data?.name}
                </p>
                {/* <p className="text-[#161616] ml-4 text-[14px]">{data?.title}</p> */}
                <p className="text-[#161616] m-4 text-[14px]">{data?.text}</p>
                <a href={data?.link} target="_blank" rel="noopener noreferrer">
                  {" "}
                  <img className="mx-4 cursor-pointor" src={Linkdein} alt="" />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Fade>
  );
};

export default Team;
